import { JetpacB2BApi } from 'api' // NOTE: Assuming a B2B-specific API client exists. Please replace with the correct one.

class B2bRebateApi {
  static async createRebate(body: TenantRebateBackendData, faberToken: string) {
    return JetpacB2BApi.httpPost(
      `tenant-rebate`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static async getRebateById(id: string, faberToken: string) {
    return JetpacB2BApi.httpGet(`tenant-rebate/${id}`, {
      Authorization: `Bearer ${faberToken}`
    })
  }
  static async updateRebate(body: TenantRebateBackendData, faberToken: string) {
    return JetpacB2BApi.httpPut(
      `tenant-rebate`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default B2bRebateApi

export interface TenantRebateTier {
  rebate_tier_name: string
  from_amount: number
  to_amount: number
  rebate_percentage: number
}

export interface TenantRebateBackendData {
  tenant_id: string
  rebate_tier_name: string
  rebate_period: string
  from_amount: number
  to_amount: number
  rebate_percentage: number
  is_active: boolean
  created_by: string
  updated_by: string
  tenant_rebate_tier: TenantRebateTier[]
}
